import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { UserService } from '../../services/user-service/user.service';
import { CommonModule } from '@angular/common';
import { DialogService } from '../../customs/_modal/dialog.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [RouterLink, MatFormFieldModule,CommonModule ,MatInputModule, MatButtonModule, MatCheckboxModule, ReactiveFormsModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordForm: FormGroup;
  isToggled = false;
  hide = true;
  hide2 = true;
  token: string = '';
  message = '';
  error = '';

  constructor(
    public themeService: CustomizerSettingsService,
    private fb: FormBuilder,
    private authService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService
    
  ) {
    this.resetPasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]
    }, {
      validators: this.passwordsMatchValidator
    });

    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'] || '';
    });
  }

  passwordsMatchValidator(form: FormGroup) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { mismatch: true };
  }
onSubmit() {
  if (this.resetPasswordForm.valid && this.token) {
    const newPassword = this.resetPasswordForm.value.password;
    console.log('[INFO] Envoi du nouveau mot de passe avec token :', this.token);

    this.authService.resetPassword(this.token, newPassword).subscribe({
      next: (res) => {
        console.log('[SUCCESS]', res);
                this.dialogService.openSuccessDialog('Mot de passe réinitialisé avec succès.')
        this.error = '';
        setTimeout(() => this.router.navigate(['/authentication']), 1000);
      },
      error: (err) => {
        console.error('[ERREUR] Réinitialisation échouée :', err);
        this.dialogService.openDangerDialog( 'Erreur lors de la réinitialisation du mot de passe.');
        this.message = '';
      }
    });
  }
}

}
